import React from 'react';
import {PURPOSE_OPTIONS, type ItemPurpose} from '../../support/itemLifecycle';
import type {ItemFormValues, UseItemForm} from '../../hooks/useItemForm';
import type {ItemFormRefs} from './types';
import {ChipGroup, FieldRow, SelectField} from './ItemFormControls';

export interface ItemFormWearContextProps {
    values: ItemFormValues;
    refs: ItemFormRefs;
    setField: UseItemForm['setField'];
    toggle: UseItemForm['toggle'];
}

/** Когда и куда носится вещь: сезоны, погода, поводы, стили, слой, теплота. */
const ItemFormWearContext: React.FC<ItemFormWearContextProps> = ({values, refs, setField, toggle}) => (
    <>
        <ChipGroup
            legend="Сезоны"
            testId="item-chips-seasons"
            options={refs.seasons}
            selected={values.seasonIds}
            onToggle={id => toggle('seasonIds', id)}
        />
        <ChipGroup
            legend="Подходящая погода"
            testId="item-chips-weather"
            options={refs.weatherSuitabilities}
            selected={values.weatherSuitabilityIds}
            onToggle={id => toggle('weatherSuitabilityIds', id)}
        />
        <ChipGroup
            legend="Поводы"
            testId="item-chips-occasions"
            options={refs.occasions}
            selected={values.occasionIds}
            onToggle={id => toggle('occasionIds', id)}
        />
        {/* Стили описывают вещь, а не вкус владельца: предпочтения сюда не подставляются (QA-13). */}
        <ChipGroup
            legend="Стили"
            testId="item-chips-styles"
            options={refs.styles}
            selected={values.styleIds}
            onToggle={id => toggle('styleIds', id)}
        />
        <ChipGroup
            legend="Слои"
            testId="item-chips-layers"
            options={refs.layers}
            selected={values.layerIds}
            onToggle={id => toggle('layerIds', id)}
        />
        <FieldRow>
            <SelectField
                id="item-warmth"
                label="Уровень тепла"
                value={values.warmthLevelId}
                options={refs.warmthLevels}
                onChange={v => setField('warmthLevelId', v)}
            />
            <SelectField
                id="item-formality"
                label="Формальность"
                value={values.formalityId}
                options={refs.formalities}
                onChange={v => setField('formalityId', v)}
            />
        </FieldRow>
        <div>
            <label htmlFor="item-purpose" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Назначение
            </label>
            <select
                id="item-purpose"
                data-testid="item-purpose"
                value={values.purpose}
                onChange={e => setField('purpose', e.target.value as ItemPurpose)}
                className="input-field"
            >
                {PURPOSE_OPTIONS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
        </div>
    </>
);

export default ItemFormWearContext;
